<template>
	<div style="text-align: center;">
		
		<span class="go-index" @click="pageTo('/order/cashkefu')">投诉</span>
			
		<div class="pay-info" style="border-bottom: 1px solid #f5f5f5;">

			<br /><br /><br /><br /><br />

			<span
				style="width: 8rem;  margin: 0 auto; display: block; font-size: 0.8rem; text-align: center; ">订单付款</span>

			<br /><br /><br />

			<span>金额</span><br /><br>
			<span style="display: inline-block;float: left; font-size: 1.2rem;">￥</span>
			<input ref="feeInput" class="pay-fee" type="text" v-model.number="fee"/>
			<br /><br><br>
			<input ref="noteInput" class="pay-note" type="text" v-model="note" placeholder="添加备注(方便我们找到你的订单)" />
			<br /><br />

 
 
			<span class="pay-tips" @click="fee='200'">200</span>
			<span class="pay-tips" @click="fee='300'">300</span>
			<span class="pay-tips" @click="fee='500'">500</span>
			<span class="pay-tips" @click="fee='800'">800</span>
			<br>
			<span class="pay-tips" @click="fee='1000'">1000</span>
			<span class="pay-tips" @click="fee='1500'">1500</span>
			<span class="pay-tips" @click="fee='2000'">2000</span>
			<span class="pay-tips" @click="fee='2500'">2500</span>

			<br><br>

		</div>

		<div class="pay-list" style="display: none;">
			<span class="icon-box"><i class="iconfont icon-weixin"></i></span>
			<span>微信支付-原生</span>
			<span style="float: right;"><input type="radio" value="1" v-model="channel" /></span>
		</div>
		<div class="pay-list" style="display: none;">
			<span class="icon-box"><i class="iconfont icon-zhifubao"></i></span>
			<span>支付宝支付-原生</span>
			<span style="float: right;"><input type="radio" value="2" v-model="channel" /></span>
		</div>
		<div class="pay-list">
			<span class="icon-box"><i class=""></i></span>
			<span>拉卡拉支付-推荐</span>
			<span style="float: right;"><input type="radio" value="3" v-model="channel" /></span>
		</div>

		<br><br>
		<span class="pay-buttom" @click="toPay()">确认支付</span>




		<!-- 支付宝1 -->
		<form v-bind:action="alipay.action" method="post" name="punchout_form">
			<input type="hidden" name="biz_content" v-model="alipay.biz_content">
			<input type="submit" value="立即支付" style="display: none;">
		</form>
		<br /><br /><br />



		<!-- 组件使用 -->
		<!-- <foot /> -->
		<syalert ref="syalert_id" />

	</div>
</template>
<style>
	.pay-info {
		font-size: 0.5rem;
		text-align: left;
		/* border: 1px solid #f5f5f5; */
		width: 90%;
		margin: 0 auto;
	}
	.pay-fee {
		width: 12rem;
		float: left;
		font-size: 1.8rem;
		/* height: 1.2rem; */
		color: #FF5810;
	}
	.pay-fee:focus
	{
		caret-color: #FF5810;
	}

	.pay-note
	{
		display: none;
		width: 16rem;
		font-size: 0.8rem;
	}
	.pay-note:focus
	{
		caret-color: #FF5810;
	}

	.pay-tips
	{
		display: inline-block;
		width: 2rem;
		padding: 0.2rem 0.5rem;
		margin: 0.1rem 0.1rem;

		text-align: center;

		border: 1px solid #f5f5f5;
		border-radius: 0.2rem;
	}

	.pay-list {
		margin: 0.5rem auto;
		width: 80%;
		text-align: left;
	}

	.pay-list span {
		display: inline-block;
	}

	.pay-list input {
		height: 2.5rem;
	}

	.icon-box {
		width: 2.5rem;
		height: 2.5rem;
		margin-right: 1.0rem;
		border-radius: 2.5rem;
		border: 1px solid #f5f5f5;
		line-height: 2.5rem;
		text-align: center;
	}
	
	.icon-weixin {
		color: #09BB07;
	}

	.icon-zhifubao {
		color: #1890FF;
	}

	.pay-buttom {
		display: block;
		width: 16rem;
		height: 2rem;
		margin: 0.5rem auto;

		line-height: 2rem;

		/* border-radius: 2rem; */

		font-size: 0.8rem;

		color: white;
		background-color: #FF5810;
	}
</style>
<script>
	// 组件引入
	import sy from "@/sy";
	import syalert from '@/components/syalert.vue';
	// import foot from '@/components/foot.vue';

	export default {
		name: 'cashpay',
		components: {
			// foot,
			syalert,
		},
		data() {
			return {
				fee: '', // 金额 / 金额快捷id 实际前端自行修改
				note: '',
				channel: 3, // 支付类型 pay
				alipay: {
					action: '',
					biz_content: '',
				},
				inte: '',
			}
		},
		methods: {
			pageTo: function(page) {
				if (page !== undefined) {
					this.$router.push(page);
				} else {
					this.$router.go(-1);
				}
			},
			check: function()
			{
				//console.log('----------');
				//console.log(this.forms);
			},
			toPay: function()
			{
				if( this.note == '' )
				{
					// 获取焦点
					// this.$refs.noteInput.focus();
					// return this.$refs.syalert_id.syalert('请添加订单备注');
				}
				
				// 记得对无备注的 做一下提示
				// 重命名实例
				let $_this = this;
				sy.http.get(
				{
					url: this.$root.API + 'Paycash/Add',
					data:
					{
						fee: this.fee,
						note: this.note,
						pay: this.channel,
					},
					success: function(res)
					{
						if (res.state === '0')
						{
							return $_this.$refs.syalert_id.syalert(res.msg);
						}
						if ( $_this.channel == 1 )
						{
							// weixin
						}
						if ( $_this.channel == 2 )
						{
							// $_this.alipay = res.data;
							$_this.alipay.action = res.data.action;
							$_this.alipay.biz_content = res.data.biz_content;
							// 如果有提示会一直给他提示 知道处理完

							$_this.inte = setInterval(function()
							{
								if ($_this.alipay.action !== '')
								{
									clearInterval($_this.inte);
									// 触发表单按钮
									document.forms[0].submit();
								}
							}, 500);

							//alert($_this.channel);
						}
						// 拉卡拉 - 自动跳转
						if ( $_this.channel == 3 )
						{
							location.href = res.data.h5url;
						}
					}
				});
			},
		},
		created() {
			// this.fee = this.fee.toFixed(2);
			this.check();
		},
		mounted() {
			this.$refs.feeInput.focus();
		}
	}
</script>